function MessageMediaEmpty({ userId }) {
	this.userId = userId;
}

export default MessageMediaEmpty;
